import * as React from 'react';
import { Button as FlowBiteButton, ButtonProps as FlowBiteButtonProps } from 'flowbite-react';
import { ButtonColorsEnum, ButtonSizesEnum, buttonTheme } from '../../styles/themes/button';
import { Text } from '../text';

export type ButtonProps = Omit<FlowBiteButtonProps, 'label' | 'size' | 'color'> & {
    label: string;
    size: ButtonSizesEnum;
    color: ButtonColorsEnum;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    ariaLabel?: string;
};

export const Button: React.FC<ButtonProps> = (props) => {
    const { label, startIcon, endIcon, ...otherProps } = props;
    const fontSize = React.useMemo(() => {
        if (otherProps.size === 'xs') {
            return 'xs';
        } else if (['sm', 'md'].includes(otherProps.size as string)) {
            return 'sm';
        }
        return 'base';
    }, [otherProps.size]);

    return (
        <FlowBiteButton theme={buttonTheme} {...otherProps}>
            {startIcon ? startIcon : null}
            <Text variant="label-medium">
                {label}
            </Text>
            {endIcon ? endIcon : null}
        </FlowBiteButton>
    );
};
